module.exports = __webpack_public_path__ + "static/media/siteminder.177a9906.svg";